// projects/slice.js

import { projectsInitialState } from "./projectsState";
import { makeProjectsActions } from "./projectsActions";

export const createProjectsSlice = (set, get) => ({
  projects: projectsInitialState,
  projectsActions: Object.freeze(makeProjectsActions(set, get)),
});
